import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 7,
	stroke: "#000",
	viewBox: "0 0 13 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.5 1L6.125 6L11.75 1",
		strokeWidth: 1.5
	})
});
export default SvgArrowDown;
